<template>
	<div class="flex flex-col relative">
		<div
			class="flex items-center bg-[#E6E6E6] py-1 px-3 rounded-sm cursor-pointer"
			@click="() => toggle()"
		>
			<div class="flex gap-2 items-center text-[#4B4B4D]">
				<Icon
					icon="mingcute:filter-line"
					class="icon"
				/>
				<p class="text-sm !m-0">
					{{ label }}
				</p>
			</div>
			<Icon
				icon="fluent:caret-up-20-filled"
				class="icon"
				rotate="2"
			/>
		</div>
		<div
			v-if="opened"
			ref="optionsContainer"
			class="flex flex-col absolute top-8 shadow w-full py-2 bg-white"
			style="z-index: 1; overflow-y: auto; max-height: 200px"
		>
			<span
				v-for="option in options"
				:key="option.key"
				class="py-1 cursor-pointer hover:bg-[#E6E6E6] px-4 text-sm"
				@click="
					emit('input', option.key)
					opened = false
				"
			>
				{{ option.label }}
			</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { Icon } from '@iconify/vue2'

import { onClickOutside, useToggle } from '@vueuse/core'
import { computed, ref } from 'vue'

const optionsContainer = ref(null)

const emit = defineEmits(['input'])

const [opened, toggle] = useToggle(false)

type Option = {
	key: string
	label: string
}

const props = defineProps<{
	options: Option[]
	value: string
}>()

const label = computed(
	() => props.options.find((f) => f.key === props.value)?.label || 'Escolha uma opção',
)

onClickOutside(optionsContainer, () => {
	if (opened) opened.value = false
})
</script>
